import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  Box,
  Switch,
  CircularProgress,
  FormControlLabel,
  Radio,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import keyicon from "../../assets/svg/SideBar/keyicon.svg";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import "./enterprises.css";
import {
  AddenterpriseForStcher,
  Editenterprise,
} from "../../store/enterprise/action";
import { validateEnterpriseKeyApi } from "../../services/enterprise/enterprise";

const Enterprises = ({ open, OnClose, editdata }) => {
  const [formState, setFormState] = useState({
    EnterpriseName: "",
    EnterpriseDescription: "",
    IsActive: true,
    EnterpriseTypeID: "",
    EnterpriseEmail: "",
    EnterpriseID: "",
    EnterpriseToken: "",
    MacInterFaces: null,
    HostName: null,
    MachineUUID: null,
    DriveSerialNumber: null,
    OSSerialNumber: null,
  });
  const [uniqueCode, setUniqueCode] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [validatedKey, setValidatedKey] = useState(null);
  const dispatch = useDispatch();
  const [screenerStudioOrClickOps, setScreenerStudioOrClickOps] =
    useState("screenerStudio");

  const validateForm = () => {
    const newErrors = {};
    if (!formState.EnterpriseName)
      newErrors.EnterpriseName = "Enterprise Name is required.";
    if (!formState.EnterpriseEmail)
      newErrors.EnterpriseEmail = "Email is required.";
    if (!formState.EnterpriseDescription)
      newErrors.EnterpriseDescription = "Description is required.";
    // if (!formState.EnterpriseToken)
    //   newErrors.EnterpriseToken = "Token is required.";
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClick = async () => {
    if (!validateForm()) return;
    setLoading(true);
    if (screenerStudioOrClickOps !== "screenerStudio") {
      try {
        const res = await dispatch(Editenterprise(formState));
        if (res) {
          OnClose();
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        // console.log(formState);
        const payload = {
          ClientName: formState.EnterpriseName,
          ClientID: formState.EnterpriseID,
          Description: formState.EnterpriseDescription,
          Email: formState.EnterpriseEmail,
          UniqueKey: uniqueCode,
          IsActive: formState.IsActive,
          MacInterFaces: formState.MacInterFaces,
          HostName: formState.HostName,
          MachineUUID: formState.MachineUUID,
          DriveSerialNumber: formState.DriveSerialNumber,
          OSSerialNumber: formState.OSSerialNumber,
        };
        const res = await dispatch(AddenterpriseForStcher(payload));
        if (res) {
          OnClose();
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        setFormState({
          EnterpriseName: "",
          EnterpriseDescription: "",
          IsActive: true,
          EnterpriseTypeID: "",
          EnterpriseEmail: "",
          EnterpriseID: "",
          EnterpriseToken: "",
          MacInterFaces: null,
          HostName: null,
          MachineUUID: null,
          DriveSerialNumber: null,
          OSSerialNumber: null,
        });
        setUniqueCode("");
      }
    }
  };

  const handleGenerate = () => {
    if (!formState.EnterpriseName) {
      setUniqueCode("Enterprise Name is required to generate a code.");
      return;
    }
    const generatedCode = `${uuidv4()}`;
    setUniqueCode(generatedCode);
    setFormState((prev) => ({ ...prev, EnterpriseToken: generatedCode }));
  };

  const handleClose = () => {
    OnClose();
    setErrors({});
    setFormState({
      EnterpriseName: "",
      EnterpriseDescription: "",
      IsActive: true,
      EnterpriseTypeID: "",
      EnterpriseEmail: "",
      EnterpriseID: "",
      EnterpriseToken: "",
      MacInterFaces: null,
      HostName: null,
      MachineUUID: null,
      DriveSerialNumber: null,
      OSSerialNumber: null,
    });
    setUniqueCode("");
    setValidatedKey(null);
    setScreenerStudioOrClickOps("screenerStudio");
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const onChangeKey = (e) => {
    setValidatedKey(e.target.value);
  };

  const handleValidate = async () => {
    if (validatedKey) {
      const res = await validateEnterpriseKeyApi({
        EncryptedKey: validatedKey,
      });
      // normalize response data to a common shape and autofill the form
      const apiData = res?.data?.data;
      // helper to pull potential fields from different shapes
      const normalize = (d) => {
        if (!d) return null;
        // possible keys mapping from API examples
        const enterpriseId =
          d.EnterpriseID || d.ClientID || d.ClientId || d.ClientId;
        const name =
          d.OrganizationStructureName ||
          d.ClientName ||
          d.ClientName ||
          d.ClientName ||
          d.OrganizationStructureName;
        const description =
          d.OrganizationStructureDescription || d.Description || d.Description;
        const email = d.OrganizationStructureEmail || d.Email || d.Email;
        const token =
          d.OrganizationStructureToken ||
          d.ClientToken ||
          d.UniqueKey ||
          d.ClientToken ||
          d.OrganizationStructureToken;
        const macs = d.MacInterFaces || d.MacInterFaces || null;
        const host = d.HostName || d.HostName || null;
        const machineUUID = d.MachineUUID || d.MachineUUID || null;
        const driveSerial = d.DriveSerialNumber || d.DriveSerialNumber || null;
        const osSerial = d.OSSerialNumber || d.OSSerialNumber || null;

        return {
          EnterpriseID: enterpriseId,
          EnterpriseName: name || "",
          EnterpriseDescription: description || "",
          EnterpriseEmail: email || "",
          EnterpriseToken: token || "",
          MacInterFaces: macs,
          HostName: host,
          MachineUUID: machineUUID,
          DriveSerialNumber: driveSerial,
          OSSerialNumber: osSerial,
          UniqueKey: d.UniqueKey || token || "",
        };
      };

      const normalized = normalize(apiData);
      if (normalized) {
        // populate the form state with normalized values
        setFormState((prev) => ({
          ...prev,
          EnterpriseName: normalized.EnterpriseName,
          EnterpriseDescription: normalized.EnterpriseDescription,
          IsActive: true,
          EnterpriseEmail: normalized.EnterpriseEmail,
          EnterpriseID: normalized.EnterpriseID,
          EnterpriseToken: normalized.EnterpriseToken,
          MacInterFaces: normalized.MacInterFaces,
          HostName: normalized.HostName,
          MachineUUID: normalized.MachineUUID,
          DriveSerialNumber: normalized.DriveSerialNumber,
          OSSerialNumber: normalized.OSSerialNumber,
        }));

        // set the unique code field shown in the UI
        if (normalized.UniqueKey) setUniqueCode(normalized.UniqueKey);
      }
    }
  };

  useEffect(() => {
    if (editdata) {
      if (editdata?.EnterpriseType === "ScreenerStudio") {
        setScreenerStudioOrClickOps("screenerStudio");
      } else {
        setScreenerStudioOrClickOps("clickOps");
      }
      setFormState(editdata);
      setUniqueCode(editdata?.EnterpriseToken);
    }
  }, [editdata]);

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          background: "#f8fafc",
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap="16px">
          <img src={keyicon} alt="logo" />
          <Box>
            <Typography variant="h6">
              {editdata ? "Edit Enterprise" : "New Enterprise"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              The Add/Edit an Enterprise allows users to create new enterprise
              or modify existing ones{" "}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap="24px">
          <Divider />

          <Box>
            <Typography>Organization Generated Key</Typography>
            <Box display="flex" alignItems="center" gap="8px">
              <TextField
                type="text"
                value={validatedKey}
                onChange={onChangeKey}
                placeholder="Enter encrypted key..."
                fullWidth
                size="small"
              />
              <Button variant="contained" onClick={handleValidate} size="small">
                Validate
              </Button>
            </Box>
          </Box>
          <TextField
            label="Enterprise Name"
            name="EnterpriseName"
            onChange={onChange}
            value={formState.EnterpriseName}
            error={!!errors.EnterpriseName}
            helperText={errors.EnterpriseName}
            fullWidth
            size="small"
          />
          <TextField
            label="Enterprise Description"
            name="EnterpriseDescription"
            onChange={onChange}
            value={formState.EnterpriseDescription}
            error={!!errors.EnterpriseDescription}
            helperText={errors.EnterpriseDescription}
            fullWidth
            multiline
            rows={3}
            size="small"
          />
          <Box>
            <Typography className="input-label" variant="body2">
              Select Option
            </Typography>
            <FormControlLabel
              control={
                <Radio
                  checked={screenerStudioOrClickOps === "screenerStudio"}
                  onChange={(e) => setScreenerStudioOrClickOps(e.target.value)}
                  value="screenerStudio"
                />
              }
              label="Screener Studio"
            />
            <FormControlLabel
              control={
                <Radio
                  checked={screenerStudioOrClickOps === "clickOps"}
                  onChange={(e) => setScreenerStudioOrClickOps(e.target.value)}
                  value="clickOps"
                />
              }
              label="ClickOps"
            />
          </Box>

          <TextField
            label="Email"
            type="email"
            name="EnterpriseEmail"
            onChange={onChange}
            value={formState.EnterpriseEmail}
            error={!!errors.EnterpriseEmail}
            helperText={errors.EnterpriseEmail}
            fullWidth
            size="small"
          />

          <Box>
            <Typography>Unique Code</Typography>
            <Box display="flex" alignItems="center" gap="8px">
              <TextField value={uniqueCode} readOnly fullWidth size="small" />
              <Button
                variant="contained"
                onClick={handleGenerate}
                size="small"
                disabled={!!uniqueCode}
              >
                Generate Code
              </Button>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="center" gap="16px">
              <Switch
                checked={formState.IsActive}
                onChange={() =>
                  setFormState((prev) => ({
                    ...prev,
                    IsActive: !prev.IsActive,
                  }))
                }
              />
              <Box>
                <Typography variant="body2">Status</Typography>
                <Typography variant="caption">Change status</Typography>
              </Box>
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: formState.IsActive ? "#15803D" : "#B91C1C",
                backgroundColor: formState.IsActive ? "#F0FDF4" : "#FEF2F2",
                px: 2,
                py: 0.5,
                borderRadius: "16px",
              }}
            >
              {formState.IsActive ? "Active" : "Inactive"}
            </Typography>
          </Box>

          <Divider />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box mt={3} display="flex" justifyContent="space-between" gap={2}>
          <Button
            variant="outlined"
            onClick={handleClose}
            fullWidth
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleClick}
            fullWidth
            size="small"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Save"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default Enterprises;
